









































































































































import { Vue, Component, Prop } from "vue-property-decorator";
import NewInputDialog from "./NewInputDialog.vue";
import InputTile from "./InputTile.vue";

@Component({
  components: {
    NewInputDialog,
    InputTile
  }
})
export default class SectionTile extends Vue {
  store = this.$store.direct;

  @Prop() index!: number;

  get sections() {
    return this.store.state.template.selected.sections;
  }

  get section() {
    return this.store.state.template.selected.sections[this.index];
  }

  swapUp() {
    this.store.commit.template.SWAP_SECTION_UP(this.index);
  }

  swapDown() {
    this.store.commit.template.SWAP_SECTION_DOWN(this.index);
  }

  removeSection() {
    this.store.commit.template.REMOVE_SECTION_FROM_SELECTED(this.index);
  }
}
